var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.72499 0 0 4.71449 0 10.521C0 15.771 3.84299 20.1285 8.86199 20.916V13.566H6.19499V10.521H8.86199V8.20049C8.86199 5.56499 10.4265 4.116 12.831 4.116C13.9755 4.116 15.1725 4.3155 15.1725 4.3155V6.90899H13.8495C12.5475 6.90899 12.138 7.71749 12.138 8.54701V10.521H15.057L14.5845 13.566H12.138V20.916C14.6122 20.5252 16.8653 19.2628 18.4904 17.3565C20.1155 15.4503 21.0056 13.0259 21 10.521C21 4.71449 16.275 0 10.5 0Z",
    fill: "#E3E6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.cea89aac575d32999a5617be185ced42.svg";
export { ForwardRef as ReactComponent };